import { CommercePlatform } from "@spscommerce/services";
import axios from "axios";
import { parseUrlSearch } from "./url";
export class AuthService {
    environment: string;
    identityUri: string;
    commercePlatform: CommercePlatform;

    constructor(environment: string, commercePlatform: CommercePlatform) {
        this.commercePlatform = commercePlatform;
        this.environment = environment;
        this.identityUri =
            this.environment !== "prod"
                ? `https://${this.environment}.id.spsc.io/identity`
                : "https://id.spsc.io/identity";
    }

    async sendPasswordResetEmail(emailAddress: string) {
        return this.postPassword(await this.commercePlatform.getAppBaseUrl(), emailAddress);
    }

    postPassword(url: string, emailAddress: string) {
        return axios.post(`${this.identityUri}/users/forgot-password/`, {
            email_address: emailAddress,
            verification_url: url + "create-new-password",
        });
    }

    async getPasswordPolicy() {
        return axios.get(`${this.identityUri}/v2/users/password-policy`);
    }

    async resetPassword(params: any) {
        return axios.post(`${this.identityUri}/users/reset-password/`, params);
    }

    async getToken(username: string, password: string) {
        const urlSearch = parseUrlSearch(window.location.href);
        const organization_id = urlSearch["cp.orgid"];
        return axios.post(`${this.identityUri}/token/`, {
            username: username,
            password: password,
            client_id: 595,
            grant_type: "password",
            organization_id,
        });
    }
}
